export const queryKeys = {
    fetchUsers: {
        all: ['fetchUsers'] as const,
    },
    fetchMentors: {
        all: ['fetchMentors'] as const,
        one: ['findMentorByID'] as const,
        menteesWithSessions: (mentorId: number) => ['mentorMenteesWithSessions', mentorId] as const,
        profileCompletionStats: ['mentorProfileCompletionStats'] as const,
        breakdown: ['mentorBreakdown'] as const,
    },
    fetchMentees: {
        all: ['fetchMentees'] as const,
        one: ['findMenteeByID'] as const,
        sessions: (menteeId: number) => ['fetchMenteeSessions', menteeId] as const,
        preferenceStats: ['menteePreferenceStats'] as const,
        breakdown: ['menteeBreakdown'] as const,
    },
    fetchCriteria: {
        all: ['fetchCriteria'] as const,
    },
    seasons: {
        all: ['seasons'] as const,
    },
    fetchPreferences: {
        all: ['fetchPreferences'] as const,
        one: ['fetchPreferenceByMenteeId'] as const,
        count: ['fetchPreferenceCount'] as const,
    },
    fetchSuggestions: {
        all: ['fetchSuggestions'] as const,
        mentees: ['fetchSuggestionsForMentees'] as const,
        mentors: ['fetchMatchesForMentors'] as const,
        byMenteeId: ['fetchSuggestionsByMenteeId'] as const,
        allChoicesByMenteeId: ['fetchAllMentorChoicesByMenteeId'] as const,
    },
    fetchSettings: {
        all: ['fetchSettings'] as const,
        maxNumberOfMentees: ['maxNumberOfMentees'] as const,
        lastDateToSubmitPreferences: ['submitPreferencesDeadline'] as const,
        lastDateToSelectMentor: ['selectMentorDeadline'] as const,
    },
    effectiveDeadlines: ['effectiveDeadlines'] as const,
    deadlineExtensions: {
        all: ['deadlineExtensions'] as const,
        byUser: (userId: number) => ['deadlineExtensions', userId] as const,
    },
    fetchSummary: {
        gaps: ['fetchGaps'] as const,
        trends: ['fetchTrends'] as const,
    },
    sessionAttendance: ["sessionAttendance"] as const,
    auditLog: (params?: Record<string, unknown>) => ["auditLog", params ?? {}] as const,
    cron: {
        jobs: ["cronJobs"] as const,
        runs: (jobName?: string, status?: string) => ["cronRuns", jobName ?? "all", status ?? "all"] as const,
    },
};
